<script>
	import {pop} from "svelte-spa-router";
	import Data from "../controladores/data.svelte";
	let controlador;
	export let params;
	let detalle = "";
	let pulsaciones = "";
	let temperatura = 0;
	let peso = 0;
	function volver(){
		pop();
	}
	function agregar(){
		controlador.agregarHistoria(params.documento,detalle,peso,temperatura,pulsaciones);
	}
</script>
<Data bind:this={controlador} />
<div class="flex flex-col bg-purple-300 items-center justify-start w-screen h-screen max-w-full max-h-full">
	<h1 class="text-xl font-bold m-2">Nueva Historia</h1>	
	<span class="text-sm font-bold">Frecuencia Cardiaca</span>
	<input  class="w-3/4 p-2 m-2" type="text" placeholder="Frecuencia Cardiaca" bind:value={pulsaciones} />
	<span class="text-sm font-bold">Temperatura (C°)</span>
	<input  class="w-3/4 p-2 m-2" type="number" step="0.01" placeholder="Temperatura" bind:value={temperatura} />
	<span class="text-sm font-bold">Peso (Kg)</span>
	<input  class="w-3/4 p-2 m-2" type="number" step="0.01"  placeholder="Peso" bind:value={peso} />
	<span class="text-sm font-bold">Detalle</span>
	<input class="w-3/4 p-2 m-2" placeholder="Detalle" bind:value={detalle} />
	<div class="w-3/4 flex flex-col sm:flex-row items-center justify-between">
		<button on:click={volver} class="m-2 p-2 text-white bg-purple-500 flex items-center justify-center rounded cursor-pointer">Volver</button>
		<button on:click={agregar} class="m-2 p-2 text-white bg-purple-500 flex items-center justify-center rounded cursor-pointer">Agregar</button>
	</div>
</div>
